import { render, staticRenderFns } from "./DeleteEducationSecondModal.vue?vue&type=template&id=262990a4&"
import script from "./DeleteEducationSecondModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteEducationSecondModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports